import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=38030c40&scoped=true&"
import script from "./uploadPhoto.vue?vue&type=script&lang=js&"
export * from "./uploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=38030c40&scoped=true&lang=scss&"
import style1 from "./uploadPhoto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38030c40",
  null
  
)

export default component.exports